import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";

const jyotirlingas = [
    { name: "Somnath", location: "Prabhas Patan, Gujarat", desc: "The eternal sanctuary of Lord Shiva by the ocean.", image: "/assets/jyotirlingas/somnath.jpg" },
    { name: "Mallikarjuna", location: "Srisailam, Andhra Pradesh", desc: "The sacred hill shrine on the banks of Krishna River.", image: "/assets/jyotirlingas/mallikarjuna.jpg" },
    { name: "Mahakaleshwar", location: "Ujjain, Madhya Pradesh", desc: "The lord of time where eternity stands still.", image: "/assets/jyotirlingas/mahakaleshwar.jpg" },
    { name: "Omkareshwar", location: "Mandhata, Madhya Pradesh", desc: "The island temple shaped in the sacred Om symbol.", image: "/assets/jyotirlingas/omkareshwar.jpg" },
    { name: "Kedarnath", location: "Kedarnath, Uttarakhand", desc: "The abode of Shiva amidst the Himalayan peaks.", image: "/assets/jyotirlingas/kedarnath.jpg" },
    { name: "Bhimashankar", location: "Khed, Maharashtra", desc: "Nestled in the Sahyadri hills, a sanctuary of peace.", image: "/assets/jyotirlingas/bhimashankar.jpg" },
    { name: "Kashi Vishwanath", location: "Varanasi, Uttar Pradesh", desc: "The golden temple in the city of light and liberation.", image: "/assets/jyotirlingas/kashi_vishwanath.jpg" },
    { name: "Trimbakeshwar", location: "Trimbak, Maharashtra", desc: "Near the source of the holy Godavari river.", image: "/assets/jyotirlingas/trimbakeshwar.jpeg" },
    { name: "Vaidyanath", location: "Deoghar, Jharkhand", desc: "The divine healer — lord of all ailments and sorrow.", image: "/assets/jyotirlingas/vaidyanath.jpg" },
    { name: "Nageshwar", location: "Dwarka, Gujarat", desc: "The lord of all serpents, protector of devotees.", image: "/assets/jyotirlingas/nageshwar.jpg" },
    { name: "Rameshwaram", location: "Rameswaram, Tamil Nadu", desc: "Where Lord Ram himself worshipped Lord Shiva.", image: "/assets/jyotirlingas/rameshwaram.jpg" },
    { name: "Grishneshwar", location: "Verul, Maharashtra", desc: "The compassionate lord — the last of the twelve.", image: "/assets/jyotirlingas/grishneshwar.jpg" }
];

const JyotirlingaSlider = () => {
    const [current, setCurrent] = useState(0);
    const [paused, setPaused] = useState(false);
    const total = jyotirlingas.length;
    const timerRef = useRef(null);

    const next = useCallback(() => setCurrent((c) => (c + 1) % total), [total]);
    const prev = useCallback(() => setCurrent((c) => (c - 1 + total) % total), [total]);

    // Auto-slide every 3 seconds
    useEffect(() => {
        if (paused) return;
        timerRef.current = setInterval(() => {
            next();
        }, 1500);
        return () => clearInterval(timerRef.current);
    }, [paused, next]);

    // Reset timer on manual navigation
    const handlePrev = () => {
        clearInterval(timerRef.current);
        prev();
    };
    const handleNext = () => {
        clearInterval(timerRef.current);
        next();
    };

    const getCard = (offset) => jyotirlingas[(current + offset + total) % total];

    return (
        <section
            className="relative bg-gray-50 pt-20 pb-16 px-6 overflow-hidden select-none"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
        >

            {/* Background watermark text */}
            <div
                className="absolute inset-0 flex items-center justify-center pointer-events-none"
                style={{ zIndex: 0 }}
            >
                <span
                    className="text-[12vw] font-black uppercase text-gray-200/60 whitespace-nowrap tracking-widest"
                    style={{ letterSpacing: "0.15em" }}
                >
                    JYOTIRLINGA
                </span>
            </div>

            <div className="max-w-6xl mx-auto relative" style={{ zIndex: 1 }}>

                {/* Header */}
                <div className="text-center mb-12">
                    <div className="flex items-center justify-center gap-3 mb-3">
                        <div className="h-px w-10 bg-gray-400" />
                        <p className="text-gray-500 text-sm font-semibold tracking-widest uppercase">Explore India's</p>
                        <div className="h-px w-10 bg-gray-400" />
                    </div>
                    <h2 className="text-5xl md:text-7xl font-black text-gray-800 uppercase tracking-tight leading-none">
                        12 JYOTIRLINGAS
                    </h2>
                </div>

                {/* Cards */}
                <div className="relative flex items-center justify-center gap-6 h-[380px]">

                    {/* Left card (prev) */}
                    <div
                        className="hidden md:block flex-shrink-0 w-[220px] h-[290px] rounded-3xl overflow-hidden cursor-pointer opacity-60 hover:opacity-75 transition-all duration-500 shadow-lg"
                        onClick={prev}
                        style={{ transform: "scale(0.88) translateX(30px)" }}
                    >
                        <img
                            key={getCard(-1).image}
                            src={getCard(-1).image}
                            alt={getCard(-1).name}
                            className="w-full h-full object-cover"
                            loading="lazy"
                            onError={(e) => { e.target.style.display = "none"; }}
                        />
                        <div className="absolute inset-0 bg-black/30" />
                    </div>

                    {/* Center card (active) */}
                    <Link
                        to={`/temple/${getCard(0).name}`}
                        className="flex-shrink-0 w-[90%] md:w-[500px] h-[360px] md:h-[340px] rounded-[2rem] md:rounded-3xl overflow-hidden relative shadow-2xl z-10 transition-all duration-500"
                        style={{ transform: "scale(1)" }}
                    >
                        <img
                            key={getCard(0).image}
                            src={getCard(0).image}
                            alt={getCard(0).name}
                            className="w-full h-full object-cover"
                            loading="lazy"
                            onError={(e) => { e.target.style.display = "none"; }}
                        />
                        {/* Gradient */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

                        {/* Bottom text */}
                        <div className="absolute bottom-0 left-0 right-0 p-6">
                            <h3 className="text-2xl font-black text-orange-400 mb-1">{getCard(0).name}</h3>
                            <p className="text-white/80 text-sm mb-2">{getCard(0).desc}</p>
                            <div className="flex items-center gap-1 text-white/60 text-xs">
                                <svg className="w-3 h-3 text-orange-400" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                </svg>
                                {getCard(0).location}
                            </div>
                        </div>
                    </Link>

                    {/* Right card (next) */}
                    <div
                        className="hidden md:block flex-shrink-0 w-[220px] h-[290px] rounded-3xl overflow-hidden cursor-pointer opacity-60 hover:opacity-75 transition-all duration-500 shadow-lg"
                        onClick={next}
                        style={{ transform: "scale(0.88) translateX(-30px)" }}
                    >
                        <img
                            key={getCard(1).image}
                            src={getCard(1).image}
                            alt={getCard(1).name}
                            className="w-full h-full object-cover"
                            loading="lazy"
                            onError={(e) => { e.target.style.display = "none"; }}
                        />
                        <div className="absolute inset-0 bg-black/30" />
                    </div>
                </div>

                {/* Bottom controls */}
                <div className="flex flex-col items-center gap-5 mt-10">
                    {/* Dot indicators */}
                    <div className="flex items-center gap-2 mb-1">
                        {jyotirlingas.map((_, i) => (
                            <button
                                key={i}
                                onClick={() => setCurrent(i)}
                                className={`rounded-full transition-all duration-300 ${
                                    i === current
                                        ? "w-6 h-2 bg-orange-400"
                                        : "w-2 h-2 bg-gray-300 hover:bg-gray-400"
                                }`}
                                aria-label={`Go to slide ${i + 1}`}
                            />
                        ))}
                    </div>

                    {/* Arrows */}
                    <div className="flex items-center gap-6">
                        <button
                            onClick={handlePrev}
                            className="text-black hover:scale-110 transition-transform duration-200"
                            aria-label="Previous"
                        >
                            <svg className="w-8 h-8 text-black" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <circle cx="12" cy="12" r="10" strokeWidth="2" />
                                <path d="M14 16l-4-4 4-4" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                        <button
                            onClick={handleNext}
                            className="text-black hover:scale-110 transition-transform duration-200"
                            aria-label="Next"
                        >
                            <svg className="w-8 h-8 text-black" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <circle cx="12" cy="12" r="10" strokeWidth="2" />
                                <path d="M10 8l4 4-4 4" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>

                    {/* Discover More button */}
                    <Link 
                        to="/jyotirlingas"
                        className="flex justify-center gap-2 items-center mx-auto shadow-xl text-lg bg-white backdrop-blur-md font-bold isolation-auto border-gray-50 before:absolute before:inset-y-0 before:my-auto before:-left-full before:w-full before:aspect-square before:rounded-full before:bg-sky-500 hover:text-white before:-z-10 before:transition-all before:duration-700 hover:before:left-0 hover:before:scale-150 relative z-10 px-8 py-3 overflow-hidden border-2 rounded-full group transition-transform active:scale-95"
                    >
                        <span>Discover more</span>
                        <svg
                            className="w-8 h-8 justify-end group-hover:rotate-90 group-hover:bg-white text-gray-50 ease-linear duration-300 rounded-full border border-gray-700 group-hover:border-none p-2 rotate-45 transition-all"
                            viewBox="0 0 16 19"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                                className="fill-gray-800"
                            ></path>
                        </svg>
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default JyotirlingaSlider;
